define('presentation/settings/outboundCallingCampaigns/viewModels/outboundCallingCampaignsViewModel',[
    'businessServices/authentication/accountPlanInfo',
    'businessServices/authentication/sessionAccountInfo',
    'businessServices/events/eventManager',
    'businessServices/router/router',
    'common/collections/collectionFilter',
    'common/collections/collectionSorter',
    'common/promises/promiseFactory',
    'constants/scrollEventSources',
    'presentation/common/actionModal/viewModels/actionModalViewModel',
    'presentation/settings/outboundCallingCampaigns/facades/outboundCallingCampaignsFacade',
    'presentation/settings/outboundCallingCampaigns/viewModels/noOutboundCallingPackageModalViewModel',
    'settings/navigationConfiguration'
], function(){
    return function() {
        const self = this;

        const PromiseFactoryConstructor = require('common/promises/promiseFactory');
        const _promiseFactory = new PromiseFactoryConstructor();

        const NoOutboundCallingPackageModalConstructor = require('presentation/settings/outboundCallingCampaigns/viewModels/noOutboundCallingPackageModalViewModel');

        const FilterConstructor = require('common/collections/collectionFilter');
        const SorterConstructor = require('common/collections/collectionSorter');

        /** @type typeof import('constants/scrollEventSources') */
        const ScrollEventSources = require('constants/scrollEventSources');

        const _accountPlanInfo = require('businessServices/authentication/accountPlanInfo');
        const _navigationConfiguration = require('settings/navigationConfiguration');
        const _router = require('businessServices/router/router');
        const _sessionAccountInfo = require('businessServices/authentication/sessionAccountInfo');
        const _i18n = require('i18next');

        let _disposables = [];
        let _eventManager = null;
        let _facade = null;
        let _getNextBatchCalled = false;
        let _getNextBatchOfOutboundCallingCampaignsEventId = null;

        const ROWS_PER_PAGE = 20;

        let _state = {
            availableOutboundCallingCampaigns: ko.observableArray([]),
            filteredOutboundCallingCampaigns: [],
            outboundCallingCampaignsShown: 0
        };

        const _showMissingOutboundCallingPackage = () => {
            _buildNoOutboundCallingPackageModal();
            self.actionModal.showModal();
        };

        const _buildNoOutboundCallingPackageModal = () => {
            const constructorParams = [_sessionAccountInfo.isBillingAdmin()];
            self.actionModal
                .clearModal()
                .setContentViewModel(NoOutboundCallingPackageModalConstructor, constructorParams)
                .setHeaderText({i18n: `outboundCallingCampaigns:addOutboundCalling`})
                .setShouldDisplayCancelButton(false)
                .setSubmitButtonText({i18n: 'ok'})
                .setShouldDisplayDefaultFooterMessage(true);
        };

        const _updateDisplayedOutboundCallingCampaigns = () => {
            let filteredCampaigns;
            let filterContent = self.outboundCallingCampaignFilter();
            if (filterContent !== '') {
                let outboundCallingCampaignsFilter = new FilterConstructor();
                outboundCallingCampaignsFilter.addProperty('name');
                outboundCallingCampaignsFilter.addProperty('modifiedDateTime.filterValue');
                outboundCallingCampaignsFilter.addProperty('createdDateTime.filterValue');
                outboundCallingCampaignsFilter.addProperty('domain');
                outboundCallingCampaignsFilter.addValue(filterContent);
                filteredCampaigns = outboundCallingCampaignsFilter.filter(_state.availableOutboundCallingCampaigns());

                _state.filteredOutboundCallingCampaigns = filteredCampaigns;
            }
            else {
                filteredCampaigns = _state.availableOutboundCallingCampaigns();
                _state.filteredOutboundCallingCampaigns = filteredCampaigns;
            }
        };

        const _refreshOutboundCallingCampaigns = () => {
            return _promiseFactory.defer((promise) => {
                _facade.getOutboundCallingCampaigns()
                    .fail(promise.reject)
                    .done((campaigns) => {
                        _state.availableOutboundCallingCampaigns(campaigns);
                        _state.filteredOutboundCallingCampaigns = campaigns;
                        _state.outboundCallingCampaignsShown = campaigns.length;
                        _sortDisplayedOutboundCallingCampaigns();
                        if (_getNextBatchOfOutboundCallingCampaignsEventId === null) {
                            _getNextBatchOfOutboundCallingCampaignsEventId = _eventManager.subscribeBottomScrollBufferReached(_getNextBatchOfOutboundCallingCampaigns);
                        }
                        promise.resolve();
                    });
            });
        };

        const _sortDisplayedOutboundCallingCampaigns = () => {
            let sorter = new SorterConstructor();
            if (sorter.setOptions(self.sortOptions(), self.sortType())) {
                sorter.sort(_state.availableOutboundCallingCampaigns);
                _updateDisplayedOutboundCallingCampaigns();
                self.lastPage = false;
                _state.outboundCallingCampaignsShown = ROWS_PER_PAGE;
                self.displayOutboundCallingCampaigns(_state.filteredOutboundCallingCampaigns.slice(0, _state.outboundCallingCampaignsShown));
            }
        };

        const _getNextBatchOfOutboundCallingCampaigns = (eventSource) => {
            if (eventSource !== self.scrollEventSource) {
                return;
            }

            if (self.lastPage === false && _getNextBatchCalled === false){
                _getNextBatchCalled = true;
                let additionalCampaignsShown = _state.outboundCallingCampaignsShown + ROWS_PER_PAGE;
                let additionalCampaigns = _state.filteredOutboundCallingCampaigns.slice(_state.outboundCallingCampaignsShown, additionalCampaignsShown);
                self.displayOutboundCallingCampaigns.push.apply(self.displayOutboundCallingCampaigns, additionalCampaigns);
                _state.outboundCallingCampaignsShown = additionalCampaignsShown;
                if (_state.outboundCallingCampaignsShown >= _state.filteredOutboundCallingCampaigns.length) {
                    self.lastPage = true;
                }
                _getNextBatchCalled = false;
            }
        };

        const _outboundCallingCampaignFilterOnChange = () =>{
            _updateDisplayedOutboundCallingCampaigns();
            self.lastPage = false;
            _state.outboundCallingCampaignsShown = ROWS_PER_PAGE;
            self.displayOutboundCallingCampaigns(_state.filteredOutboundCallingCampaigns.slice(0, _state.outboundCallingCampaignsShown));
        };

        self.scrollEventSource = ScrollEventSources.settingsOutboundCallingCampaigns;
        self.actionModal = null;
        self.lastPage = false;
        self.isCompositionComplete = ko.observable(false);
        self.displayOutboundCallingCampaigns = ko.observableArray([]);
        self.addOutboundCallingCampaignUrl = _navigationConfiguration.routesById.addOutboundCallingCampaign.url;
        self.cannotActivateTooltip = _i18n.t('outboundCallingCampaigns:cannotActivateTooltip');
        self.activateTooltip = _i18n.t('outboundCallingCampaigns:activateTooltip');
        self.deactivateTooltip = _i18n.t('outboundCallingCampaigns:deactivateTooltip');

        self.sortType = ko.observable("name");
        _disposables.push(self.sortType.subscribe(_sortDisplayedOutboundCallingCampaigns));
        self.sortOptions = ko.observableArray([
            {textI18n: "name", iconName: 'sortName', sortPath : "name", isAscending : true},
            {textI18n: "recentlyAdded", iconName: 'sortRecentlyAdded', sortPath : "createdDateTime.sortValue", isAscending : false},
            {textI18n: "recentlyModified", iconName: 'sortRecentlyModified', sortPath : "updatedDateTime.sortValue", isAscending : false}
        ]);
        self.outboundCallingCampaignFilter = ko.observable('');
        _disposables.push(self.outboundCallingCampaignFilter.subscribe(_outboundCallingCampaignFilterOnChange));

        self.showResults = ko.pureComputed(() => self.displayOutboundCallingCampaigns().length > 0);
        self.emptyStateContentKey = ko.pureComputed(() => _state.availableOutboundCallingCampaigns().length > 0 ?
            "outboundCallingCampaigns:noResults" :
            "outboundCallingCampaigns:noCampaigns");

        self.isImpersonating = ko.pureComputed(() => {
            return _sessionAccountInfo.isImpersonating();
        });

        self.addOutboundCallingCampaign = () => {
            if (_accountPlanInfo.hasOutboundCallingPackage()) {
                _router.navigate(self.addOutboundCallingCampaignUrl);
            } else {
                _showMissingOutboundCallingPackage();
            }
        };

        const _changeOutboundCallingCampaignActiveStatus = (campaignId, makeActive) => {
            return _promiseFactory.defer((promise) => {
                const facadePromise = _facade.changeOutboundCallingCampaignActiveStatus(campaignId, makeActive);

                facadePromise
                    .fail(promise.reject)
                    .done(() => {
                        _refreshOutboundCallingCampaigns();
                        promise.resolve();
                    });
            });
        };

        self.activateOutboundCallingCampaign = (campaign) => {
            return _changeOutboundCallingCampaignActiveStatus(campaign.outboundCallingCampaignId, true);
        };

        self.deactivateOutboundCallingCampaign = (campaign) => {
            return _changeOutboundCallingCampaignActiveStatus(campaign.outboundCallingCampaignId, false);
        };

        self.compositionComplete = () => {
            self.isCompositionComplete(true);
        };

        self.detached = () => {
            _disposables.forEach(s => s.dispose);
            _disposables = [];
            _eventManager.unsubscribe(_getNextBatchOfOutboundCallingCampaignsEventId);
        };

        self.activate = () => {
            const FacadeConstructor = require('presentation/settings/outboundCallingCampaigns/facades/outboundCallingCampaignsFacade');
            _facade = new FacadeConstructor();
            _facade.init(_promiseFactory);

            const ActionModalViewModelConstructor = require('presentation/common/actionModal/viewModels/actionModalViewModel');
            self.actionModal = new ActionModalViewModelConstructor();

            _eventManager = require('businessServices/events/eventManager');

            return _initialize();
        };

        const _initialize = () => {
            _refreshOutboundCallingCampaigns();
            return _promiseFactory.wait();
        };
    };
});

